common.View.create('canvas::canvas.blocks.utils.iframe.Block', {

	onDOMLoad()
	{
		this.initResizer();
	},

    initResizer()
	{
        iFrameResize({ log: true, resizedCallback: function(messageData){ console.log(messageData); } }, '.embed');
    }

});
